<template>
  <div class="header_title">
    <div class="_time" v-if="map_type != 1 ? true : false">
      <Time></Time>
    </div>
    <div id="container">
      <!-- <div class="table-search"> -->
      <!-- 搜索 -->
      <!-- <input placeholder="请输入..." type="text" v-model="input_value" @keydown.13="search_value">
            <p @click="search_value"><img src='../../../../static/img/search.png'/> <span class='search_text'>搜索</span></p>
        </div> -->

      <div v-if="map_type !== 3 ? true : false" class="search">
        <el-select
          v-model="selectValue"
          filterable
          remote
          clearable
          no-data-text="无符合条件的设备"
          placeholder="请输入关键词搜索"
          :remote-method="remoteMethod"
          @change="handleChange"
          :loading="loading"
        >
          <el-option
            v-for="(item, index) in optionsList"
            :key="index + '_remote'"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <!-- <div class="table-search"> -->
      <!-- 搜索 -->
      <!-- <input placeholder="请输入..." type="text" v-model="input_value" @keydown.13="search_value"> -->
      <!-- <p @click="search_value"><img src='../../../../static/img/search.png'/> <span class='search_text'>搜索</span></p>
        </div> -->
      <!--<div class='all' @click='handleAllMark' v-if="map_type!==3?true:false">全部</div>-->
      <div class="part" v-if="map_type !== 3 ? true : false">
        <el-select
          v-model="couponSelected"
          filterable
          placeholder="场景"
          @change="getCouponSelected"
        >
          <el-option
            v-for="item in couponList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </div>
      <!--<div class='part' @click='handlePart' v-if="map_type!==3?true:false">场站</div>-->
      <div
        class="returnicon"
        @click="returnHome"
        v-if="map_type !== 3 ? true : false"
      >
        返回
      </div>
      <div class="sign_out" @click="sign_out">退出</div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import localStorage from "../../../libs/js/localStorage.js";
import dataUrl from "../../../libs/js/interfaceAddress.js";
import Time from "../map/baseMap/time";

export default {
  data() {
    return {
      input_value: "",
      selectValue: [],
      optionsList: [],
      list: [],
      loading: false,
      couponList: [
        {
          key: "0",
          value: "全部"
        }
      ],
      couponSelected: ""
    };
  },
  components: {
    Time
  },
  watch: {},
  computed: {
    ...mapState(["map_type"])
  },
  created() {},
  mounted() {
    this.$bus.$off("marker-event").$on("marker-event", this.handleAllMark);
    window.updateSign_out = this.sign_out;
    this.requestDeviceScene();
  },
  methods: {
    getCouponSelected() {
      console.log("数据查询中....");
      console.log(this.couponSelected);
      this.$bus.$emit("part-marker", this.couponSelected);
    },
    requestDeviceScene() {
      this.$http
        .get(dataUrl.interfaceAddress.sceneSelect)
        .then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            if (res.data.body) {
              let arr = [1, 2];
              let arr2 = [3, 4];

              arr = arr.concat(arr2);
              this.couponList = this.couponList.concat(res.data.body);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    remoteMethod(query) {
      console.log("数据查询中fsfsf....");
      this.selectValue = [];
      this.selectValue = query;
      if (query !== "") {
        this.loading = true;
        // let search_value = encodeURIComponent(query);
        this.optionsList = [];
        this.$http
          .get(dataUrl.interfaceAddress.deviceList, {
            params: { keyWord: query, scencId: this.couponSelected }
          })
          .then(res => {
            this.loading = false;
            if (res.data.code === 0) {
              if (res.data.body) {
                var info = res.data.body;
                for (let i in info) {
                    var item = info[i]
                    var dict = {
                        value: item.deviceId,
                        label: item.deviceName
                      };
                      this.optionsList.push(dict)
                      if(this.optionsList.length>=100){
                        throw new Error("满了100个跳出当前循环-=-=-=-=-");
                      }
                }
              }
            } else{
              this.optionsList = [];
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
      }
      // let dropdown = document.querySelectorAll('.el-select-dropdown')[0]
      // if (this.optionsList.length < 2) dropdown.style.display = 'none'
      // if (this.optionsList.length >= 2) dropdown.style.display = 'inline-block'
    },
    //筛选过程选择的经纬度
    handleChange(data) {
      //原先点击搜索列表数据后地图操作 this.$emit('submitSearch', data)
      console.log("下拉数据内容-=-=-=-=-=-", data);
      this.$emit("submitSearch", [data]);
      // this.couponSelected ='';
    },
    //鼠标聚焦的时候清除optionsList
    tt() {
      this.optionsList = [];
    },
    returnHome() {
      this.$emit("returnHome");
      this.$bus.$emit("returnHome");

      //清空场景的选项里的内容
      this.couponSelected = "";
      this.selectValue = "";
    },
    //点击显示全部标盘
    handleAllMark() {
      this.$bus.$emit("change-info-event");
    },
    //显示部分场站标盘
    handlePart() {
      this.$bus.$emit("part-marker");
    },
    sign_out() {
      this.$bus.$emit("emitter-excu-sign-out-event");
      // window.localStorage.clear()
      localStorage.removeStore("info");
      localStorage.removeStore("loginStatus");
      if (document.exitFullscreen) {
        // console.log("exitFullscreen-=-=-=-="+document.exitFullscreen);
        document.exitFullscreen
          ? document.exitFullscreen()
          : document.mozCancelFullScreen
          ? document.mozCancelFullScreen()
          : document.webkitCancelFullScreen
          ? document.webkitCancelFullScreen()
          : document.msExitFullscreen
          ? document.msExitFullscreen()
          : "";
      }

      this.$router.replace({
        path: "/login"
      });
      this.$bus.$emit("closeMqtt");
    }
  }
};
</script>

<style lang="less" scoped>
.header_title {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  // height: 100%;
  #container {
    margin: 0 auto;
    height: 69px;
    position: relative;
  }

  input {
    border: none;
    outline: none;
  }

  .table-search {
    position: absolute;
    top: 30px;
    // left: 78%;
    right: 70px;
    display: flex;
    height: 25px;
    width: 100px;
    margin: 0 auto;

    p {
      display: flex;
      align-items: center;
      color: #d7d7d7;
      // background: #fff;
      // border: 1px solid #d7d7d7;
      border-left: none;
      // border-top-right-radius:15px;
      // border-bottom-right-radius:15px;
      padding-right: 10px;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
      }

      .search_text {
        cursor: pointer;
        font-size: 14px;
        color: #67c6e2;
        padding-left: 5px;
      }
    }
  }

  /*返回*/

  .returnicon {
    width: 53px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 33px;
    right: 105px;
    font-size: 14px;
    color: #67c6e2;
    text-align: right;
    /*background: url(../../../../static/img/return.png) no-repeat;*/
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/return.png)
      no-repeat;
    background-size: 30% 86%;
  }
  .all {
    width: 53px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 33px;
    right: 245px;
    font-size: 14px;
    color: #67c6e2;
    text-align: right;
    background: url(../../../../static/img/all.png) no-repeat;
    background-size: 30% 86%;
  }
  .part {
    width: 50px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: -135px;
    font-size: 14px;
    color: #67c6e2;
    text-align: right;
    /*background: url(../../../../static/img/part.png) no-repeat;*/
    background-size: 30% 86%;
  }

  /*时间*/

  ._time {
    // margin-top: 22px;
    // margin-left: 30px;
  }

  //退出登录
  .sign_out {
    width: 53px;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top: 33px;
    right: 40px;
    font-size: 14px;
    color: #67c6e2;
    text-align: right;
    /*background: url(../../../../static/img/logout.png) no-repeat;*/
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/logout.png)
      no-repeat;
    background-size: 30% 86%;
  }

  .search_list {
    background: #ffffff;
    width: 150px;
    padding: 5px 5px;
    position: absolute;
    top: 60px;
    right: 150px;
    z-index: 15;
  }
}
</style>
<style lang="less">
// .el-select-dropdown{
//     background:#28549d;
//     border: none;

// }
// .popper__arrow::after{
//     border-bottom-color:#28549d !important;
//     border: none;
// }

.el-select-dropdown__empty {
  color: #999;
}

.el-select-dropdown__wrap {
  margin-bottom: -18px !important;
}

el-select-dropdown__item {
  span {
    cursor: pointer;
  }
}
.el-icon-arrow-down:before {
  color: #67c6e2;
}

#container {
  position: relative;
  .part {
    .el-select {
      position: absolute;
      top: 30px;
      // left: 78%;
      right: 305px;
      display: flex;
      height: 25px;
      width: 95px;
      // margin: 0 auto;
      .el-input__inner {
        height: 25px;
        background: #28549d;
        border: none;
        outline: none;
        font-size: 12px;
        color: #fff;
      }

      .el-input__icon {
        line-height: 25px;
      }
    }
  }
  .search {
    .el-select {
      position: absolute;
      top: 30px;
      // left: 78%;
      right: 280px;
      display: flex;
      height: 25px;
      width: 150px;
      // margin: 0 auto;
      .el-input__inner {
        height: 25px;
        background: #28549d;
        border: none;
        font-size: 12px;
        color: #fff;
      }

      .el-input__icon {
        line-height: 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/header_top/header_top.vue